import * as Sentry from '@sentry/react'
import { useMemo } from 'react'
import { z } from 'zod'

import { capitalize } from '../../../igao/utils'
import { SearchInput } from '../search-input'
import { Select } from '../select'

import styles from './filters.module.css'

export const filtersSchema = z.record(z.object({
  selected: z.union([ z.number(), z.string() ]).nullable(),
  values: z.union([ z.string(), z.number() ]).array()
}))

export type FiltersType = Record<string, { selected: string | number | null, values: Array<string | number> }>

interface Props {
  filters?: FiltersType
  onFilterChange?: (key: keyof FiltersType, value: string | number | null) => void
  search?: string | null
  onSearchChange?: (value: string) => void
}

export function Filters ({ onSearchChange, onFilterChange, search, filters }: Props): JSX.Element | null {
  let validation = useMemo(() => filtersSchema.safeParse(filters), [ filters ])

  function handleSelectChange (key: keyof FiltersType) {
    return (value: string | number | null) => {
      onFilterChange?.(key, value)
    }
  }

  if (filters && !validation.success) {
    Sentry.captureException(validation.error)
    return null
  }

  return (
    <div className={styles.wrapper}>
      {(Object.keys(filters ?? {})).map(key => (
        <Select
          key={key}
          onChange={handleSelectChange(key)}
          options={filters?.[key]?.values}
          value={filters?.[key]?.selected}
          placeholder={key.split('_').map((val) => capitalize(val)).join(' ')}
        />
      ))}

      {typeof search === 'string' &&
        <SearchInput
          placeholder='Search'
          onChange={onSearchChange}
          value={search}
        />
      }
    </div>
  )
}
